import React from 'react';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../Components/Headers/CommonHeader';
import ActivationContent from '../Components/AccountActivation/ActivationContent';
import $ from 'jquery';

export default function About() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/Activate',
    title: 'Account Activation',
  });

  return (
    <React.Fragment>
      <CommonHeader />
      <ActivationContent />
    </React.Fragment>
  );
}
